import React, { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import ShopSyncedMaterialListPage from '@/tiktok-platform/modules/templates/ShopSyncedMaterialListPage';
import { useTiktokShopOptional } from '@/tiktok-platform/context/TiktokShopContext';
import {
  buildTiktokPath,
  parseTiktokShopTypeSlugFromPath,
} from '@/tiktok-platform/constants/tiktokRoutes';
import { tiktokShopCapabilities } from '@/tiktok-platform/utils/tiktokShopCapabilities';
import { showToast } from '@/utils/toast';

function useSkipSiteWarehouseFreightTemplateLib() {
  const activeShop = useTiktokShopOptional()?.activeShop ?? null;
  return useMemo(() => {
    const fromShop = Boolean(tiktokShopCapabilities(activeShop?.shopType).skipSiteWarehouseFreight);
    if (fromShop) return true;
    const slug = parseTiktokShopTypeSlugFromPath(
      typeof window !== 'undefined' ? window.location.pathname : '',
    );
    return slug === 'full' || slug === 'local';
  }, [activeShop?.shopType]);
}

/** 模板库 · 仓库模板（店铺同步，无官方库；全托管/本土不提供） */
export default function WarehouseTemplatePage() {
  const { t } = useTranslation('workbench');
  const navigate = useNavigate();
  const skip = useSkipSiteWarehouseFreightTemplateLib();

  useEffect(() => {
    if (!skip) return;
    showToast(t('warehouseLib.skipShop'), 'info');
    navigate(buildTiktokPath('templates/product'), { replace: true });
  }, [skip, navigate, t]);

  if (skip) return null;

  return (
    <ShopSyncedMaterialListPage
      kind="warehouse"
      libraryLabel={t('warehouseLib.library')}
      idColumnLabel={t('warehouseLib.colId')}
      nameColumnLabel={t('warehouseLib.colName')}
      syncHint={t('warehouseLib.syncHintTiktok')}
    />
  );
}
